export class User {
  constructor(
    readonly id: string,
    readonly username: string,
    readonly email: string,
    readonly role: 'admin' | 'user'
  ) {}

  isAdmin() {
    return this.role === 'admin';
  }
}
